import React from 'react';

import LazyLoad from '../../../../components/lazy-load/lazy-load';
import ProductListCard from '../product-list-card/product-list-card';
import ProductListPackageCard from '../product-list-package-card/product-list-package-card';
import ProductListSetCard from '../product-list-set-card/product-list-set-card';
import ProductListStaggeredCard from '../product-list-staggered-card/product-list-staggered-card';

import { useOptimisticData } from '../../../../shared/hooks/hooks';

import { sessionStorage } from '../../../../shared/utils/storage/storage';

import { ProductData } from '../../../../shared/types/graphql-types';
import { BundleData } from '../../../../shared/types/product';
import { ACCESSORY_TYPES } from '../../../../shared/constants/products';
import { SetSearchTypes } from '../../../../shared/constants/set-products';
import { SELECTED_PRODUCT_AVAILABILITY_STORE } from '../../../../shared/constants/storage-keys';

import './product-list-grid.scss';

interface ProductListGridProps {
  isTreadwellTabSelected: boolean;
  onAddProductClick: (
    product: ProductData | BundleData,
    idx: number,
    quantity?: number
  ) => void;
  onCheckInventoryClick: () => void;
  onViewProductClick: (product: ProductData, idx: number) => void;
  prebuiltPackages?: BundleData[];
  productSetSearchType?: SetSearchTypes;
  products?: ProductData[];
}

function ProductListGrid(props: ProductListGridProps) {
  const {
    isTreadwellTabSelected,
    onAddProductClick,
    onCheckInventoryClick,
    onViewProductClick,
    prebuiltPackages,
    productSetSearchType,
    products
  } = props;

  const optimisticData = useOptimisticData();

  function handleViewProductClick(productData, idx) {
    optimisticData.write(productData);

    if (productData) {
      sessionStorage(SELECTED_PRODUCT_AVAILABILITY_STORE, {
        availabilityStoreCode:
          productData.stock?.storeCode ||
          productData.product1?.stock?.storeCode,
        pdpUrl: productData.url || productData.prebuiltPackage?.url,
        plpUrl: window.location.pathname + window.location.search
      });
    }

    onViewProductClick?.(productData, idx);
  }

  let ConditionalProductListCard;
  let productsToDisplay;

  if (prebuiltPackages) {
    productsToDisplay = prebuiltPackages;
  } else {
    productsToDisplay = products;
  }

  return (
    <div data-testid="product-list-grid" styleName="container">
      {Array.isArray(productsToDisplay) &&
        productsToDisplay.map((productObj, idx) => {
          if (prebuiltPackages) {
            ConditionalProductListCard = ProductListPackageCard;
          } else {
            ConditionalProductListCard = ProductListCard;
          }

          if (productObj?.rearProduct) {
            ConditionalProductListCard = ProductListStaggeredCard;
          } else if (
            productObj?.accessoryType === ACCESSORY_TYPES.WINDSHIELD_WIPERS
          ) {
            ConditionalProductListCard = ProductListSetCard;
          }

          return (
            <LazyLoad
              key={
                productObj?.product1
                  ? `product-${productObj.product1?.code || idx}-${
                      productObj.product2?.code || idx
                    }`
                  : `product-${productObj?.code || idx}${
                      productObj?.rearProduct?.code
                        ? `-${productObj?.rearProduct?.code}`
                        : ''
                    }-${idx}`
              }
              placeholder={
                <div
                  id={
                    productObj?.product1
                      ? `product-code-${productObj.product1?.code}-${productObj.product2?.code}`
                      : `product-code-${productObj?.code}${
                          productObj?.rearProduct?.code
                            ? `-${productObj?.rearProduct?.code}`
                            : ''
                        }-${idx}`
                  }
                />
              }
            >
              <ConditionalProductListCard
                isTreadwellTabSelected={isTreadwellTabSelected}
                onAddProductClick={productItem =>
                  onAddProductClick?.(productObj, idx, productItem?.quantity)
                }
                onCheckInventoryClick={onCheckInventoryClick}
                onViewProductClick={() =>
                  handleViewProductClick(productObj, idx)
                }
                product={productObj}
                productSetSearchType={productSetSearchType}
              />
            </LazyLoad>
          );
        })}
    </div>
  );
}

export default ProductListGrid;
